<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.productionInform')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.prd')}}</span></router-link>
                    </li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/prd/productionInform"><span>{{$t('tlt.productionInform')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/productionInform/display"><span>{{$t('tlt.productionInform.display')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('productionInform')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>取消</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <h1>{{title}}————{{editor}}</h1>
                        <hr>
                        <div v-html="content" style="text-align: left">
                            content
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<style>
    .CodeMirror {
        border: 1px solid #eee;
        /* todo change to responsible */
        height: 260px;
    }
</style>

<script>
    import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionInform/ProductionInform";

    import 'codemirror/lib/codemirror.css'
    import 'codemirror/mode/javascript/javascript.js'
    import 'codemirror/mode/xml/xml.js'
    import 'codemirror/mode/yaml/yaml.js'
    import 'codemirror/mode/properties/properties.js'
    import 'codemirror/theme/eclipse.css'

    const {
        mapFields
    } = createHelpers({
        getterType: 'productionInform/getField',
        mutationType: 'productionInform/updateField',
    });
    export default {
        data() {
            return {
                cmOptions: {
                    tabSize: 4,
                    mode: 'text/plain',
                    theme: 'eclipse',
                    lineNumbers: true,
                    line: true,
                }
            }
        },
        mounted() {
            this.changeEditor();
            this.MMFCheckState('productionInform');
        },
        computed: {
            ...mapState({
                entity: state => state.productionInform.entity,
                content: state => state.productionInform.entity.content,
                title:state => state.productionInform.entity.title,
                editor:state => state.productionInform.entity.editor
            }),
            ...mapFields(fields),
            showValueEditor() {
                return this.$store.state.productionInform.showValueEditor
            },
            showValueInput() {
                return this.$store.state.productionInform.showValueInput
            },
            showValueBoolean() {
                return this.$store.state.productionInform.showValueBoolean
            }
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
            changeEditor() {
                var dtType = this.$store.state.productionInform.entity.dataType;
                var me = this;

                var toogleEditor = function () {
                    me.$store.commit('productionInform/toggleShowValueEditor', true);
                    me.$store.commit('productionInform/toggleShowValueInput', false);
                    me.$store.commit('productionInform/toggleShowValueBoolean', false);
                }
                var toogleInput = function () {
                    me.$store.commit('productionInform/toggleShowValueEditor', false);
                    me.$store.commit('productionInform/toggleShowValueInput', true);
                    me.$store.commit('productionInform/toggleShowValueBoolean', false);
                }
                var toogleBoolean = function () {
                    me.$store.commit('productionInform/toggleShowValueEditor', false);
                    me.$store.commit('productionInform/toggleShowValueInput', false);
                    me.$store.commit('productionInform/toggleShowValueBoolean', true);
                }

                switch (dtType) {
                    case 'X':
                        toogleEditor();
                        this.$refs.myCm.codemirror.setOption("mode", 'text/xml');
                        break;
                    case 'J':
                        toogleEditor();
                        this.$refs.myCm.codemirror.setOption("mode", 'text/javascript');
                        break;
                    case 'Y':
                        toogleEditor();
                        this.$refs.myCm.codemirror.setOption("mode", 'text/yaml');
                        break;
                    case 'P':
                        toogleEditor();
                        this.$refs.myCm.codemirror.setOption("mode", 'text/x-properties');
                        break;
                    default:
                        toogleEditor();
                        this.$refs.myCm.codemirror.setOption("mode", 'text/plain');
                        break;
                    case 'N':
                    case 'D':
                    case 'U':
                        toogleInput();
                        console.log("input")
                        break;
                    case 'B':
                        console.log("boolean")
                        toogleBoolean();
                        console.log("boolean")
                        break;
                }
            },
            validateForm() {
                this.$store.dispatch('base/MMFSave', 'productionInform');
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.$store.dispatch('base/MMFSave', 'productionInform');
                    }
                });
            }
        },
        components: {
        }
    };
</script>
